import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

export const StyledButton = styled(Button)`
    height: 28px !important;
`;
